const swea = require('swea');
const ImmediateInspectInteraction = swea.editor.interactions.ImmediateInspectInteraction;


class CustomImmediateInspectInteraction extends ImmediateInspectInteraction {
  /**
   * Constructs the interaction.
   * @param { object } options An option object, see {@link Interaction} for more info.
   * @param { editor.interactions.ImageSelectionInteraction | undefined } imageSelectionInteraction The image selection interaction, if any.
   * @public
   */  
  constructor(options = {}) {
    super(options);
    this._imageSelectionInteraction = options.imageSelectionInteraction;
  }

  /**
   * Called when inspected. Overridden to deactivate image catalog reopen.
   * @private
   * @override
   */
  _whenInspected() {
    if (this._imageSelectionInteraction && this._imageSelectionInteraction.setReopen !== undefined) {
      this._imageSelectionInteraction.setReopen(false);
    }
  }
}
export default CustomImmediateInspectInteraction;
